import FinancialTransactionCountsCard from "./FinancialTransactionCountsCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const FinancialTransactionsByWallets = () => {
  const { t } = useTranslation();
  const getBusinessTransactionsMetrics = async (
    params: MetricsAPI.GetMetricQuery
  ) => {
    try {
      const { data } = await api.metrics.getTransactionCountByWallets(params);
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <FinancialTransactionCountsCard
      title={`${t("title.financialTransactionCountsBy")} ${t("title.wallets")}`}
      onUpdate={getBusinessTransactionsMetrics}
    />
  );
};

export default FinancialTransactionsByWallets;
